import { GridColumn, TableComponent } from '@tarktech/tark-ng-utils';
import { Component, OnInit, Input } from '@angular/core';
import { Messages } from "../../../../shared/constants/ui-messages";

@Component({
    selector: 'pos-inventory-log-stock-sales-product-warning',
    templateUrl: './inventory-log-stock-sales-product-warning.component.html',
    imports: [TableComponent]
})
export class InventoryLogStockSalesProductWarningComponent implements OnInit {

  @Input('salesInventoryProducts') salesInventoryProducts: any = [];
  productColumns: Array<GridColumn> = [];
  constructor() { }

  confirmLogMessage: string;

  ngOnInit() {
    this.configureColumns();  
    this.confirmLogMessage = Messages.ConfirmLogInventory;
  }

  configureColumns() {
    this.productColumns = [
      new GridColumn({ HeaderText: 'Inventory Products', Field: 'InventoryProductName', IsSortable: true, Width: '40%' }),
      new GridColumn({ HeaderText: 'Sales Products', Field: 'SalesProductName', IsSortable: true, Width: '40%' })
    ] as Array<GridColumn>;
  }
}
